import React, {useEffect, useMemo, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import BasicTable from '../Components/Global_Components/reacttable/table';
import '../styles/Patients.scss';

import {Tooltip as ReactTooltip} from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import Swal from 'sweetalert2';
import {patientid, setAppointmentDate, sidebar} from '../Redux/Slice/rootSlice';
import {
  deletePatientAppointment,
  deletePatientBill,
  fetchPatientBill,
  fetchPatientDetailsUuid,
  fetchPatientsAppointment,
  getDoctorsList,
  getPatientAppointment,
  postAppointment,
  postPatientBillMsg,
  updatePatientAppointment
} from '../Redux/Thunk/Actions';
// import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import {formatSessionTime} from '../utils/dateTime';
import {printPDF} from '../utils/printUtils';
dayjs.extend(localizedFormat);

function PatientAppointment({
  loaderchange,
  //   enableditview,
  popupalert,
  popuptext
}) {
  const [tableheaderdata, settableheaderdata] = useState([]);
  const userdata = useSelector(state => state.counter.userdata);
  const [datacount, setdatacount] = useState();
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [searchDate, setSearchDate] = useState('');
  const [update, setUpdate] = useState('');
  const viewpatient = useNavigate();
  const sideactive = useSelector(state => state.counter.sidebarnav);
  const createpageReport = useSelector(state => state.counter.patientReportCreateredux);
  const [branches, setbranches] = useState(() => localStorage.getItem('selectedBranch') || localStorage.getItem('branch') || '');
  const [allBranches] = useState(['Valasaravakkam', 'Vadapalani']);
  const [todaysTotal, setTodaysTotal] = useState(0);
  const [initialBillDate, setInitialBillDate] = useState('');
  const [alert, setalert] = useState(false);
  const edituser = useSelector(state => state.counter.edituser);
  const appointmentDate = useSelector(state => state.counter.appointmentDate);
  const adminuser = useNavigate();
  const [changeAlert, setChangeAlert] = useState(false);
  const roledata = localStorage.getItem('role') || '';
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [closeCreatePopup, setCloseCreatePopup] = useState(false);
  const [closeEditPopup, setCloseEditPopup] = useState(false);
  const [error, seterror] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [search, setsearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [dateQuery, setDateQuery] = useState(dayjs().format('YYYY-MM-DD'));

  const [startDate, setStartDate] = useState();
  const dateStr = '2024-01-23T10:45:42.716334Z';
  const formattedDate = dayjs(dateStr).format('YYYY-MM-DD');
  const [endDate, setEndDate] = useState(dayjs().format('YYYY-MM-DD'));

  const [wawlwsjkf, setwawlwsjkf] = useState(true);
  const [MsgPopUp, setMsgPopUp] = useState(false);

  const [deleteId, setDeleteId] = useState('');
  const [remarkMsg, setRemarkMsg] = useState('');
  const [tableArchive, setTableArchive] = useState(false);
  const [remarkError, setRemarkError] = useState(false);
  const [createAppointmentPopUp, setCreateAppointmentPopUp] = useState(false);

  const [patientReportCreate, setPatientReportCreate] = useState(createpageReport);
  const [isEditAppointment, setIsEditAppointment] = useState(false);
  const [appointName, setAppointName] = useState('');
  const [editPatientID, setEditPatientId] = useState('');
  const [trigger, setTrigger] = useState(false);
  const [doctorsDetails, setDoctorsDetails] = useState('');
  const [reportStatus, setReportStatus] = useState('');
  const [session, setSession] = useState('');
  const [selectedDoctor, setSelectedDoctor] = useState('');

  const [patientSearchResults, setPatientSearchResults] = useState([]);
  const [isSearchingPatient, setIsSearchingPatient] = useState(false);
  const [showPatientDropdown, setShowPatientDropdown] = useState(false);
  const searchContainerRef = useRef(null);
  const searchTimeoutRef = useRef(null);

  const staticData = {
    p_uhid: '',
    name: '',
    date: '',
    time: '',
    branch: branches,
    service_type: '',
    doctor_id: 'Select',
    status: 'Yet to Visit',
    notes: '',
    phonenumber: '',
    patient_id: ''
  };
  const doctorsDetailsList = useSelector(state => state.counter.doctorsDetailsList);
  const [appointmentData, setAppointmentData] = useState(staticData);
  const todayDate = dayjs().format('YYYY/MM/DD').replace(/\//g, '-');
  // console.log(appointmentDate,"appointmentDateappointmentDate");

  useEffect(() => {
    console.log('appointmentData', appointmentData);
    console.log('doctorsDetailsList', doctorsDetailsList);
  }, [appointmentData, doctorsDetailsList]);

  useEffect(() => {
    const handleClickOutside = event => {
      if (searchContainerRef.current && !searchContainerRef.current.contains(event.target)) {
        setShowPatientDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, []);

  const deleteAppointment = async e => {
    if (roledata?.toLowerCase() !== 'admin') {
      Swal.fire({
        title: 'Permission Denied',
        text: 'You do not have permission to delete appointments. Only Administrators can delete appointments.',
        icon: 'warning'
      });
      return;
    }

    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(async result => {
      if (result.isConfirmed) {
        try {
          const res = await dispatch(deletePatientAppointment(e));
          setTrigger(!trigger);
          if (
            res?.meta?.requestStatus === 'fulfilled' &&
            (res?.payload?.status?.code === 200 ||
              res?.payload?.message?.toLowerCase()?.includes('deleted') ||
              typeof res?.payload === 'object')
          ) {
            Swal.fire({
              title: 'Deleted!',
              text: 'Appointment has been deleted successfully.',
              icon: 'success'
            });
          } else {
            Swal.fire({
              title: 'Error!',
              text:
                typeof res?.payload === 'string'
                  ? res.payload
                  : res?.payload?.message || 'Failed to delete appointment.',
              icon: 'error'
            });
          }
        } catch (err) {
          Swal.fire({
            title: 'Error!',
            text: err?.message || 'Failed to delete appointment.',
            icon: 'error'
          });
        }
      }
    });
  };
  const editAppointment = async e => {
    setCreateAppointmentPopUp(true);
    setIsEditAppointment(true);
    const appointmentDetails = getPatientAppointment(e);
    const response = await dispatch(appointmentDetails);
    console.log(`response -->`, response);
    let data = response.payload.data.patient_id;
    let name = data?.titles + ' ' + data?.first_name + ' ' + data?.last_name;
    setAppointmentData({
      ...appointmentData,
      p_uhid: response.payload.data?.p_uhid ? response.payload.data.p_uhid : null,
      name: response.payload.data?.p_uhid ? name : response.payload.data?.name,
      status: response.payload.data.status,
      date: response.payload.data.date,
      time: response.payload.data.time,
      branch: response.payload.data?.branch ? response.payload.data.branch : branches,
      patient_id: response.payload.data?.patient_id?.id,
      service_type: response.payload.data.service_type,
      doctor_id: response.payload.data?.doctor_id,
      phonenumber: response.payload.data?.p_uhid === null ? response.payload.data?.phonenumber : response.payload.data?.patient_id?.phonenumber
    });
    setEditPatientId(response.payload.data.id);
  };
  const dropdownhandlechange = (id, event) => {
    if (id) {
      viewpatient('/PatientView');
      dispatch(patientid(id));
      console.log(id);
    }
  };

  const onHandleChange = e => {
    console.log(e.target.value, e.target.name);
    setAppointmentData({
      ...appointmentData,
      [e.target.name]: e.target.value
    });
  };
  const onHandleDateChange = e => {};
  const handleBranchChange = e => {
    setbranches(e.target.value);
    setdtPageindex(1);
  };
  // const deletePatientBillPopup = (e, event) => {
  //   setConfirmDeletePop(true)
  //   setDeleteId(e)
  // }

  const confirmDelete = async e => {
    if (remarkMsg.trim() == '') {
      setRemarkError(true);
      return;
    }
    console.log(remarkMsg);
    setMsgPopUp(false);
    const payload = {
      rme: {
        remarks: remarkMsg
      },
      id: deleteId
    };
    console.log(deleteId, 'idddddd');
    const msgResponse = postPatientBillMsg(payload);
    const response = await dispatch(msgResponse);
    console.log(response, 'daniel');

    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this bill',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(async result => {
      if (result.isConfirmed) {
        await dispatch(deletePatientBill(deleteId));
        setDeleteId(null);
        Swal.fire({
          title: 'Deleted!',
          text: 'Your file has been deleted.',
          icon: 'success'
        });
      }
    });

    // setConfirmDeletePop(false)
  };

  const updateData = async () => {
    const dataInitPayload = {
      page: dtpageindex,
      page_size: dtpagesize,
      search: searchQuery,
      from_date: dayjs().format('YYYY-MM-DD'),
      branch: branches,
      // to_date: dayjs().format("YYYY-MM-DD"),
      range: false
    };
    const patentDetailss = fetchPatientBill(dataInitPayload);
    const responsePatentDetailss = await dispatch(patentDetailss);
    if (responsePatentDetailss?.payload?.status?.code === 200) {
      setTodaysTotal(responsePatentDetailss.payload.data.total_bill_price);
      setwawlwsjkf(false);
    }
  };

  const handleUhidChange = e => {
    const value = e.target.value;
    setAppointmentData(prev => ({
      ...prev,
      p_uhid: value,
      patient_id: value.trim() === '' ? '' : prev.patient_id
    }));

    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    const trimmed = value.trim();
    if (trimmed.length < 2) {
      setPatientSearchResults([]);
      setShowPatientDropdown(false);
      setIsSearchingPatient(false);
      return;
    }

    setShowPatientDropdown(true);
    setIsSearchingPatient(true);

    searchTimeoutRef.current = setTimeout(async () => {
      try {
        const payload = {
          search: trimmed,
          skipBranchFilter: true,
          page_size: 15
        };
        const response = await dispatch(fetchPatientDetailsUuid(payload));
        if (response.payload?.status?.code === 200) {
          const list = response.payload?.data?.data || [];
          setPatientSearchResults(list);
        } else {
          setPatientSearchResults([]);
        }
      } catch (err) {
        console.error('Error searching patients:', err);
        setPatientSearchResults([]);
      } finally {
        setIsSearchingPatient(false);
      }
    }, 250);
  };

  const handleSelectPatient = patient => {
    const fullName = `${patient?.titles ? patient.titles + ' ' : ''}${patient?.first_name || ''} ${patient?.last_name || ''}`.trim();
    setAppointName(fullName);
    setAppointmentData(prev => ({
      ...prev,
      patient_id: patient?.id || '',
      p_uhid: patient?.p_uhid || '',
      name: fullName,
      phonenumber: patient?.phonenumber || '',
      branch: prev.branch || patient?.branch || branches
    }));
    setShowPatientDropdown(false);
    setPatientSearchResults([]);
  };

  const handleSetUserData = e => {
    if (e.target.name === 'dateTime') {
      console.log(e.target.value.split('T'));
      setAppointmentData({
        ...appointmentData,
        date: e.target.value.split('T')[0],
        time: e.target.value.split('T')[1]
      });
    } else {
      setAppointmentData({
        ...appointmentData,
        [e.target.name]: e.target.value
      });
    }
  };

  const createNewAppointment = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      console.log(`createNewAppointment -->`);
      if (appointmentData.p_uhid === '') {
        let data = {...appointmentData, p_uhid: null, patient_id: null};
        try {
          const response = await dispatch(postAppointment(data)).unwrap();
          if (response?.status?.code === 200) {
            Swal.fire({
              title: 'Successful.',
              text: 'Appointment added successful.',
              icon: 'success',
              showConfirmButton: false,
              timer: 1500
            });
          } else {
            Swal.fire({
              title: 'Error.',
              text: `${response?.status?.message ? response?.status?.message : 'Appointment not added.'}`,
              icon: 'warning',
              showConfirmButton: false,
              timer: 1500
            });
          }
        } catch (error) {
          console.error('Error saving Appointment:', error);
          Swal.fire({
            title: 'Error.',
            text: `Error saving Appointment`,
            icon: 'warning',
            showConfirmButton: false,
            timer: 1500
          });
        } finally {
          setTrigger(!trigger);
          setCreateAppointmentPopUp(false);
          setShowPatientDropdown(false);
        }
      } else {
        try {
          const response = await dispatch(postAppointment(appointmentData)).unwrap();

          if (response?.status?.code === 200) {
            Swal.fire({
              title: 'Successful.',
              text: `${response?.status?.message ? response?.status?.message : 'Appointment added successful.'}`,
              icon: 'success',
              showConfirmButton: false,
              timer: 1500
            });
          } else {
            Swal.fire({
              title: 'Error.',
              text: `${response?.status?.message ? response?.status?.message : 'Appointment not added.'}`,
              icon: 'warning',
              showConfirmButton: false,
              timer: 1500
            });
          }
        } catch (error) {
          console.error('Error saving Appointment:', error);
          Swal.fire({
            title: 'Error.',
            text: `Error saving Appointment`,
            icon: 'warning',
            showConfirmButton: false,
            timer: 1500
          });
        } finally {
          setTrigger(!trigger);
          setCreateAppointmentPopUp(false);
          setShowPatientDropdown(false);
        }
      }
    } finally {
      setIsSubmitting(false);
    }
  };
  const saveEditAppointment = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      console.log(appointmentData, 'isEditAppointment');
      let data = {
        appointmentData: appointmentData,
        editPatientID: editPatientID
      };
      const response = await dispatch(updatePatientAppointment(data)).unwrap();
      try {
        if (response?.status?.code === 200) {
          Swal.fire({
            title: 'Successful.',
            text: `${response?.status?.message ? response?.status?.message : 'Appointment edited successful.'}`,
            icon: 'success',
            showConfirmButton: false,
            timer: 1500
          });
        } else {
          Swal.fire({
            title: 'Error.',
            text: `${response?.status?.message ? response?.status?.message : 'Appointment not added.'}`,
            icon: 'warning',
            showConfirmButton: false,
            timer: 1500
          });
        }
      } catch (error) {
        Swal.fire({
          title: 'Error.',
          text: `Error saving Appointment`,
          icon: 'warning',
          showConfirmButton: false,
          timer: 1500
        });
      } finally {
        setTrigger(!trigger);
        setCreateAppointmentPopUp(false);
        setShowPatientDropdown(false);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const dataPayload = {
        page: dtpageindex,
        page_size: dtpagesize,
        search: searchQuery,
        branch: branches,
        date: appointmentDate,
        status: reportStatus,
        range: true,
        session: session,
        doctor_id: selectedDoctor
      };

      const getDelay = setTimeout(() => {}, 3000);
      const patentAppintmentDetails = fetchPatientsAppointment(dataPayload);
      const responsePatentDetails = await dispatch(patentAppintmentDetails);
      console.log(responsePatentDetails);
      // setTrigger(!trigger)
      if (responsePatentDetails?.payload?.status?.code === 200) {
        settableheaderdata(responsePatentDetails.payload.data);
        setdatacount(responsePatentDetails.payload.total_count);
      }
    };

    fetchData();
  }, [
    dtpageindex,
    dtpagesize,
    search,
    searchQuery,
    branches,
    update,
    startDate,
    deleteId,
    endDate,
    tableArchive,
    todaysTotal,
    createAppointmentPopUp,
    trigger,
    dateQuery,
    reportStatus,
    session,
    selectedDoctor
  ]);

  const fetchDataToday = async (start, end) => {
    const dataInitPayload = {
      page: dtpageindex,
      page_size: dtpagesize,
      search: searchQuery,
      branch: branches,
      from_date: start,
      to_date: end,
      range: true
    };
    const patentDetails = fetchPatientBill(dataInitPayload);
    const responsePatentDetails = await dispatch(patentDetails);
    if (responsePatentDetails?.payload?.status?.code === 200) {
      setTodaysTotal(responsePatentDetails.payload.data.total_bill_price);
      setwawlwsjkf(false);
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: 'SI No.',
        accessor: '',
        Cell: row => {
          // console.log("SI noooo")
          return (
            <>
              <span>
                <div style={{marginTop: '3px'}} data-tooltip-id='my-tooltip' data-tooltip-content={String(1 + Number(row.row.id))}>
                  {1 + Number(row.row.id)}.
                </div>
              </span>
            </>
          );
        }
      },
      {
        Header: 'Patient Name',
        accessor: '',
        Cell: row => {
          // console.log(row.row.original.username)
          return (
            <>
              <span>
                <div style={{marginTop: '3px'}} data-tooltip-id='my-tooltip' data-tooltip-content={String(row.row.original.name)}>
                  {row.row.original.name}
                </div>
              </span>
            </>
          );
        }
      },
      {
        Header: 'Patient ID',
        accessor: '',
        Cell: row => {
          // console.log(row.row.original.username)
          return (
            <>
              <span>
                <div style={{marginTop: '3px'}} data-tooltip-id='my-tooltip' data-tooltip-content={String(row.row.original.p_uhid)}>
                  {row.row.original.p_uhid}
                </div>
              </span>
            </>
          );
        }
      },
      {
        Header: 'Service Type',
        accessor: '',
        Cell: row => {
          // console.log(row.row.original.username)
          return (
            <>
              <span>
                <div style={{marginTop: '3px'}} data-tooltip-id='my-tooltip' data-tooltip-content={String(row.row.original.service_type)}>
                  {row.row.original.service_type}
                </div>
              </span>
            </>
          );
        }
      },

      {
        Header: 'Doctor',
        accessor: '',
        Cell: row => {
          let doctorName;
          doctorsDetailsList.forEach(ele => {
            if (ele.id === row.row.original.doctor_id) {
              doctorName = ele.user_name;
            }
          });

          return (
            <>
              <span>
                <div style={{marginTop: '3px'}} data-tooltip-id='my-tooltip' data-tooltip-content={String(doctorName)}>
                  {doctorName}
                  {/* doc */}
                </div>
              </span>
            </>
          );
        }
      },
      {
        Header: 'Date',
        accessor: '',
        Cell: row => {
          // const final_value = row.row.original.created_at.slice(0, 10);
          // const [year, month, day] = final_value.split("-");
          // const formattedDate = `${day}-${month}-${year}`;
          const rawDate = row.row.original.date;
          const date = rawDate.split('-').reverse().join('-');
          console.log(date);
          return (
            <>
              <span>
                <div style={{marginTop: '3px'}} data-tooltip-id='my-tooltip' data-tooltip-content={date}>
                  {date}
                </div>
              </span>
            </>
          );
        }
      },
      {
        Header: 'Time',
        accessor: '',
        Cell: row => {
          const timeParts = row.row.original?.time?.split(':');
          if (!timeParts) {
            return (
              <>
                <span>
                  <div style={{marginTop: '3px'}}>--:--</div>
                </span>
              </>
            );
          }
          const formatTime = `${Math.abs(timeParts[0] <= 12 && timeParts[0] != '00' ? timeParts[0] : timeParts[0] - 12)}:${timeParts[1]} ${timeParts[0] - 12 < 0 ? 'AM' : 'PM'}`;
          return (
            <>
              <span>
                <div style={{marginTop: '3px'}} data-tooltip-id='my-tooltip' data-tooltip-content={formatTime}>
                  {formatTime}
                </div>
              </span>
            </>
          );
        }
      },

      {
        Header: 'Session',
        accessor: '',
        Cell: row => {
          const time = row.row.original?.time;
          if (!time) {
            return (
              <>
                <span>
                  <div style={{marginTop: '3px'}}>Morning</div>
                </span>
              </>
            );
          }
          const [hours] = time.split(':').map(Number);
          const formatTime = hours >= 15 ? 'Evening' : 'Morning';
          return (
            <>
              <span>
                <div style={{marginTop: '3px'}} data-tooltip-id='my-tooltip' data-tooltip-content={formatTime}>
                  {formatTime}
                </div>
              </span>
            </>
          );
        }
      },
      {
        Header: 'Status',
        accessor: '',
        Cell: row => {
          // console.log(row.row.original.username)
          return (
            <>
              <span>
                <div style={{marginTop: '3px'}} data-tooltip-id='my-tooltip' data-tooltip-content={String(row.row.original.status)}>
                  {row.row.original.status}
                </div>
              </span>
            </>
          );
        }
      },

      {
        // * delete table icon
        Header: tableArchive ? 'Remarks' : 'Actions',

        accessor: '',
        Cell: row => {
          if (tableArchive) {
            return (
              <div className='style' style={{width: '150px', height: '50px', overflow: 'scroll'}}>
                <div data-tooltip-id='my-tooltip' data-tooltip-content={String(row.row.original.remarks)}>
                  {row.row.original.remarks}
                </div>
              </div>
            );
          } else {
            return (
              <div className='style'>
                <button type='button' class='btn btn-danger btn-sm trash' style={{display: 'flex', gap: '4px'}} onClick={e => deleteAppointment(row.row.original.id, e)}>
                  <i onClick={e => deleteAppointment(row.row.original.id, e)} class='bi bi-trash'></i> Delete
                </button>
                <button type='button' class='btn btn-danger btn-sm delete' style={{display: 'flex', gap: '4px'}} onClick={e => editAppointment(row.row.original.id, e)}>
                  <i onClick={e => editAppointment(row.row.original.id, e)} class='bi bi-pen'></i> Edit
                </button>
                {row.row.original.patient_id !== null && (
                  // <Link
                  // style={{ textDecoration:"none"}}

                  // onClick={() => dispatch(patientid(row.row.original.patient_id.id))} to={"/PatientView"} target="_blank">
                  <button
                    type='button'
                    class='btn btn-danger btn-sm delete'
                    style={{display: 'flex', gap: '4px', textDecoration: 'none'}}
                    onClick={e => dropdownhandlechange(row.row.original.patient_id.id, e)}>
                    <i class='bi bi-eye-fill'></i> View
                  </button>
                  // </Link>
                )}
              </div>
            );
          }
        }
      }
    ],
    [createAppointmentPopUp, dateQuery, trigger, searchQuery]
  );

  const createAppointmentFunc = async e => {
    const doctorsList = await dispatch(getDoctorsList());

    setDoctorsDetails(doctorsList.payload.data);

    setAppointmentData({
      p_uhid: '',
      name: '',
      date: '',
      time: '',
      branch: branches,
      service_type: '',
      doctor_id: 'Select',
      status: 'Yet to Visit',
      phonenumber: '',
      notes: '',
      patient_id: ''
    });
    setPatientSearchResults([]);
    setIsSearchingPatient(false);
    setShowPatientDropdown(false);
    setIsEditAppointment(false);
    setCreateAppointmentPopUp(true);
  };
  const editPatientPopup = e => {
    dispatch(patientid(e));
    setCloseEditPopup(true);
  };

  const [finalPatientsData, setFinalPatientsData] = useState('');

  const pagesize = arg => {
    setdtPagesize(arg);
  };

  const pageindex = arg => {
    setdtPageindex(arg);
  };
  const handleSubmit = event => {
    event.preventDefault();
  };

  const patientId = useSelector(state => state.counter.patientid);

  const [value, setValue] = React.useState(dayjs());

  const handlePrintPdf = () => {
    const headers = {
      name: 'Patient Name',
      p_uhid: 'Patient ID',
      service_type: 'Service Type',
      doctorName: 'Doctor',
      date: 'Date',
      time: 'Time',
      session: 'Session',
      status: 'Status'
    };

    console.log(`tableheaderdata -->`, tableheaderdata);
    console.log(`doctorsDetailsList -->`, doctorsDetailsList);

    const data = tableheaderdata.map(item => {
      const session = formatSessionTime(item.time);
      console.log(`item -->`, item);
      const doctor = doctorsDetailsList.find(doctor => doctor.id === item.doctor_id);

      const doctorName = doctor ? `${doctor.first_name} ${doctor.last_name}` : '';
      return {
        ...item,
        session: session,
        doctorName
      };
    });
    printPDF({title: 'Patient Appointment', headers, data});
  };

  return (
    <div className={sideactive ? 'maincontainer-patient-sa' : 'maincontainer-patient'}>
      <div className='patient-header'>
        <div className='row'>
          <div className='col'>
            <h3 className='page-title'>Patient Appointment</h3>
            <ul className='breadcrumb'>
              <li className='breadcrumb-item'>
                <a
                  href='/'
                  style={{textDecoration: 'none', color: 'black'}}
                  onClick={e => {
                    dispatch(sidebar('DashBoard'));
                  }}>
                  Dashboard
                </a>
              </li>
              <li className='breadcrumb-item active'>Patient Appointment</li>
            </ul>
          </div>
        </div>

        <div className='add_btn' style={{display: 'flex', gap: '10px'}}>
          <button onClick={handlePrintPdf} className='btn_1'>
            Print
          </button>{' '}
          <button onClick={createAppointmentFunc} className='btn_1'>
            Create Appointment
          </button>
        </div>
      </div>

      <div className='billableCard'>
        <p>
          {dateQuery === dayjs().format('YYYY-MM-DD')
            ? `Today's Appointment Overview ( Total : ${datacount !== undefined ? datacount : '0'})`
            : `${dateQuery} Appointment Overview ( Total : ${datacount !== undefined ? datacount : '0'})`}
          {/* ? `Today's Appointment Overview `
            : `${dateQuery} Appointment Overview `} */}
          {/* &nbsp;:&nbsp; */}
          {/* <span>{todaysTotal ?? 0}&nbsp;Rs</span> */}
        </p>
      </div>
      <div className='row' style={{marginTop: 20}}>
        <div className='col-lg-12'>
          <div className='card'>
            <div className='card-body'>
              <div className='patient'>
                <div className='table-content-patient'>
                  <form onSubmit={handleSubmit} style={{display: 'flex', justifyContent: 'space-between'}}>
                    <div class='input-group rounded' style={{width: '250px', height: '40px'}}>
                      <input
                        type='search'
                        class='form-control rounded'
                        aria-label='Search'
                        aria-describedby='search-addon'
                        // value={searchQuery}
                        style={{
                          height: '40px'
                        }}
                        // onChange={e=>{
                        //   if(e.target.value.length === 0){
                        //     setDateQuery(dayjs().format("YYYY-MM-DD"))
                        //   }
                        // }}
                        // onKeyDown={(e) => {
                        //   if (e.target.value.length === 0 && e.which === 32) {
                        //     e.preventDefault();
                        //   }
                        // }}
                        onChange={e => {
                          setTimeout(() => {
                            setSearchQuery(e.target.value);
                            setdtPageindex(1);
                          }, 800);
                        }}
                        // onKeyDown={(e)=>{if(e.which=="32"){
                        //   e.preventDefault()
                        // }}}

                        min='0'
                        max='10'
                        label='Search'
                        placeholder='Search...'
                        // required
                      />

                      <span class='input-group-text border-0 bg-transparent p-0' id='search-addon'>
                        <i
                          class='bi bi-search'
                          style={{
                            color: '#1b5a90',
                            width: '20px',
                            height: '20px',
                            marginLeft: '10px'
                          }}></i>
                      </span>
                    </div>
                    {/* <div >
                      <select className="form-select" onChange={currentableData}>
                        <option value="all">All</option>
                        <option value="archived">Cancelled</option>
                      </select>
                    </div> */}
                    <div
                      style={{
                        display: 'flex',
                        gap: '10px'
                      }}>
                      <select
                        name='branch'
                        style={{width: '200px', height: '40px'}}
                        className='form-control rounded'
                        value={branches}
                        onChange={handleBranchChange}>
                        <option value=''>All Branches</option>
                        {[...new Set([...allBranches, ...(branches ? [branches] : [])])].map(branch => (
                          <option value={branch} key={branch}>
                            {branch}
                          </option>
                        ))}
                      </select>

                      <select
                        name='session'
                        style={{width: '200px', height: '40px'}}
                        className='form-control rounded'
                        onChange={e => {
                          setSession(e.target.value);
                        }}>
                        <option selected value=''>
                          Session
                        </option>
                        <option value='morning'>Morning</option>
                        <option value='evening'>Evening</option>
                      </select>

                      <select
                        name='doctorName'
                        style={{width: '200px', height: '40px'}}
                        className='form-control rounded'
                        onChange={e => {
                          setSelectedDoctor(e.target.value);
                        }}>
                        <option selected value=''>
                          Select doctor
                        </option>
                        {doctorsDetailsList !== '' &&
                          doctorsDetailsList !== undefined &&
                          doctorsDetailsList.map(doctor => {
                            console.log(`doctor -->`, doctor);
                            const doctorName = doctor ? `${doctor.first_name} ${doctor.last_name}` : '';

                            return (
                              <option value={doctor.id} key={doctor.id}>
                                {doctorName}
                              </option>
                            );
                          })}
                      </select>
                      {/* <select
                        name='doctor'
                        style={{width: '200px', height: '40px'}}
                        className='form-control rounded'
                        onChange={e => {
                          setSession(e.target.value);
                        }}>
                        <option selected value=''>
                          Session
                        </option>
                        {doctorsDetailsList.map(doctor => (
                          <option value={doctor.user_name}>{doctor.user_name}</option>
                          
                        ))}
                      </select> */}

                      <select
                        name='status'
                        style={{width: '200px', height: '40px'}}
                        className='form-control rounded'
                        onChange={e => {
                          setReportStatus(e.target.value);
                        }}>
                        <option selected value=''>
                          All
                        </option>
                        <option value='Yet To Visit'>Yet To Visit</option>
                        <option value='Visited'>Visited</option>
                        <option value='Not Visited'>Not Visited</option>
                        <option value='Rescheduled'>Rescheduled</option>
                      </select>
                      <input
                        style={{width: '200px', height: '40px'}}
                        value={appointmentDate}
                        className='form-control rounded'
                        type='date'
                        onChange={e => {
                          setDateQuery(e.target.value);
                          // console.log(e.target.value,"i88888",appointmentDate);

                          dispatch(setAppointmentDate(e.target.value));
                          setSearchQuery('');
                        }}
                      />
                    </div>
                  </form>

                  <div className='table-patient'>
                    <BasicTable columns={columns} data={tableheaderdata} pagesize={pagesize} pageindex={pageindex} dtpagesize={dtpagesize} dtpageindex={dtpageindex} datacount={datacount} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {createAppointmentPopUp && (
        <div className='appointmentCreatePopUp'>
          <div className='appointmentCPContainer appointmentBoxResize'>
            <section className='appointmentCPBox'>
              <section>
                <h1>{isEditAppointment ? `Edit Appointment` : `Create Appointment`}</h1>
                <h2
                  onClick={() => {
                    setCreateAppointmentPopUp(false);
                    setAppointmentData(staticData);
                    setShowPatientDropdown(false);
                    setPatientSearchResults([]);
                  }}>
                  X
                </h2>
              </section>

              <div className='divBox'>
                <section className='uhidNameContainer'>
                  <div ref={searchContainerRef} style={{position: 'relative'}}>
                    <label className='uhidlable'>UHID :</label>
                    <br />
                    <div style={{position: 'relative'}}>
                      <input
                        type='text'
                        onChange={handleUhidChange}
                        onFocus={() => {
                          if (patientSearchResults.length > 0) {
                            setShowPatientDropdown(true);
                          }
                        }}
                        autoComplete='off'
                        name='p_uhid'
                        placeholder='Search UHID, name, phone...'
                        className='form-control'
                        value={appointmentData.p_uhid}
                      />
                      {isSearchingPatient && (
                        <div
                          style={{
                            position: 'absolute',
                            right: '10px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '5px',
                            fontSize: '11px',
                            color: '#0284c7',
                            fontWeight: 500,
                            pointerEvents: 'none'
                          }}>
                          <div
                            className='spinner-border spinner-border-sm'
                            style={{width: '12px', height: '12px', borderWidth: '1.5px'}}
                            role='status'
                          />
                        </div>
                      )}
                    </div>

                    {showPatientDropdown && (
                      <div
                        style={{
                          position: 'absolute',
                          top: 'calc(100% + 4px)',
                          left: 0,
                          width: '420px',
                          maxWidth: 'calc(100vw - 40px)',
                          backgroundColor: '#ffffff',
                          border: '1px solid #e2e8f0',
                          borderRadius: '8px',
                          boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.15), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
                          maxHeight: '260px',
                          overflowY: 'auto',
                          zIndex: 9999
                        }}>
                        {isSearchingPatient && patientSearchResults.length === 0 ? (
                          <div
                            style={{
                              padding: '14px 12px',
                              fontSize: '12px',
                              color: '#64748b',
                              textAlign: 'center',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '8px'
                            }}>
                            <div
                              className='spinner-border spinner-border-sm text-primary'
                              style={{width: '13px', height: '13px', borderWidth: '2px'}}
                              role='status'
                            />
                            <span>Searching patients...</span>
                          </div>
                        ) : patientSearchResults.length > 0 ? (
                          <>
                            <div
                              style={{
                                padding: '5px 12px',
                                fontSize: '10.5px',
                                fontWeight: 600,
                                color: '#94a3b8',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                borderBottom: '1px solid #f1f5f9',
                                backgroundColor: '#f8fafc'
                              }}>
                              Matching Patients ({patientSearchResults.length})
                            </div>
                            {patientSearchResults.map(patient => {
                              const fullName = `${patient?.titles ? patient.titles + ' ' : ''}${patient?.first_name || ''} ${patient?.last_name || ''}`.trim();
                              return (
                                <div
                                  key={patient.id}
                                  onClick={() => handleSelectPatient(patient)}
                                  style={{
                                    padding: '7px 12px',
                                    cursor: 'pointer',
                                    borderBottom: '1px solid #f8fafc',
                                    transition: 'all 0.15s ease'
                                  }}
                                  onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#f1f5f9')}
                                  onMouseLeave={e => (e.currentTarget.style.backgroundColor = '#ffffff')}>
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between',
                                      gap: '8px'
                                    }}>
                                    <span
                                      style={{
                                        fontWeight: 600,
                                        fontSize: '12.5px',
                                        color: '#1e293b',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis'
                                      }}>
                                      {fullName || 'Unnamed Patient'}
                                    </span>
                                    <span
                                      style={{
                                        backgroundColor: '#eff6ff',
                                        color: '#1d4ed8',
                                        border: '1px solid #dbeafe',
                                        padding: '1px 7px',
                                        borderRadius: '4px',
                                        fontSize: '10.5px',
                                        fontFamily: 'monospace',
                                        fontWeight: 600,
                                        flexShrink: 0
                                      }}>
                                      {patient.p_uhid}
                                    </span>
                                  </div>
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '6px',
                                      marginTop: '3px',
                                      fontSize: '11px',
                                      color: '#64748b',
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis'
                                    }}>
                                    {patient.phonenumber && (
                                      <span
                                        style={{
                                          display: 'inline-flex',
                                          alignItems: 'center',
                                          gap: '3px',
                                          color: '#334155'
                                        }}>
                                        <i
                                          className='bi bi-telephone-fill'
                                          style={{fontSize: '9px', color: '#0284c7'}}
                                        />
                                        {patient.phonenumber}
                                      </span>
                                    )}
                                    {patient.gender && (
                                      <>
                                        <span style={{color: '#cbd5e1', fontSize: '9px'}}>•</span>
                                        <span>{patient.gender}</span>
                                      </>
                                    )}
                                    {patient.age !== null &&
                                    patient.age !== undefined &&
                                    patient.age !== '' &&
                                    Number(patient.age) > 0 ? (
                                      <>
                                        <span style={{color: '#cbd5e1', fontSize: '9px'}}>•</span>
                                        <span>{patient.age} yrs</span>
                                      </>
                                    ) : null}
                                    {patient.branch && (
                                      <>
                                        <span style={{color: '#cbd5e1', fontSize: '9px'}}>•</span>
                                        <span
                                          style={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: '2px'
                                          }}>
                                          <i
                                            className='bi bi-geo-alt'
                                            style={{fontSize: '9.5px', color: '#94a3b8'}}
                                          />
                                          {patient.branch}
                                        </span>
                                      </>
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          </>
                        ) : (
                          <div
                            style={{
                              padding: '14px 12px',
                              fontSize: '12px',
                              color: '#94a3b8',
                              textAlign: 'center'
                            }}>
                            <i className='bi bi-search' style={{marginRight: '6px', fontSize: '11px'}} />
                            No patients found matching "{appointmentData.p_uhid}".
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  <div>
                    <label>Name :</label>
                    <br />
                    <input
                      type='text'
                      // defaultValue={appointName}
                      onChange={handleSetUserData}
                      autoComplete='off'
                      name='name'
                      className='form-control'
                      value={appointmentData.name}
                    />
                  </div>
                </section>
                <section className='uhidNameContainer'>
                  <div>
                    <label>Service Type :</label>
                    <br />
                    <input type='text' onChange={handleSetUserData} name='service_type' autoComplete='off' className='form-control' value={appointmentData.service_type} />
                    {/* <span>hello</span> */}
                  </div>
                  <div>
                    <label>Doctor :</label>
                    <br />
                    <select name='doctor_id' onChange={handleSetUserData} value={appointmentData.doctor_id}>
                      <option value='Select' selected disabled>
                        Select
                      </option>
                      {doctorsDetailsList !== '' &&
                        doctorsDetailsList !== undefined &&
                        doctorsDetailsList.map(item => {
                          return (
                            <option value={item.id} key={item.id}>
                              {item.user_name}
                            </option>
                          );
                        })}
                    </select>
                  </div>
                </section>
                <section className='uhidNameContainer'>
                  <div>
                    <label>Branch :</label>
                    <br />
                    <select name='branch' onChange={handleSetUserData} className='form-control' value={appointmentData.branch}>
                      <option value=''>Select</option>
                      {allBranches.map(branch => (
                        <option value={branch} key={branch}>
                          {branch}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label>Date :</label>
                    <br />
                    <input onChange={handleSetUserData} name='dateTime' type='datetime-local' autoComplete='off' className='form-control' value={appointmentData.date + 'T' + appointmentData.time} />
                  </div>
                </section>
                <section className='uhidNameContainer'>
                  <div>
                    <label>Phone Number :</label>
                    <br />
                    <input type='text' onChange={handleSetUserData} autoComplete='off' name='phonenumber' maxlength='10' className='form-control' value={appointmentData.phonenumber} />
                    {/* <span>hello</span> */}
                  </div>
                  <div>
                    <label>Status : </label>
                    <br />
                    <select
                      name='status'
                      // onChange={onHandleChange}
                      onChange={handleSetUserData}
                      className='form-control'
                      value={
                        appointmentData.status
                        // isEditAppointment ? appointmentData.status : "Select"
                      }>
                      <option selected value='Yet to Visit'>
                        Yet to Visit
                      </option>
                      <option value='Not Visited' key=''>
                        Not Visited
                      </option>
                      <option value='Visited' key=''>
                        Visited
                      </option>
                      <option value='Rescheduled' key=''>
                        Rescheduled
                      </option>
                    </select>
                  </div>
                </section>
                <div className='buttonDiv'>
                  <button
                    disabled={
                      isSubmitting ||
                      !(
                        appointmentData.date !== '' &&
                        appointmentData.branch !== '' &&
                        appointmentData.service_type !== '' &&
                        appointmentData.name !== '' &&
                        appointmentData.status !== 'select' &&
                        appointmentData.phonenumber !== '' &&
                        appointmentData.time !== ''
                      )
                    }
                    className={
                      !isSubmitting &&
                      appointmentData.date !== '' &&
                      appointmentData.branch !== '' &&
                      appointmentData.name !== '' &&
                      appointmentData.service_type !== '' &&
                      appointmentData.status !== 'select' &&
                      appointmentData.doctor_id.toLocaleLowerCase() !== 'select' &&
                      appointmentData.phonenumber !== '' &&
                      appointmentData.time !== ''
                        ? ''
                        : 'disabled'
                    }
                    onClick={isEditAppointment ? saveEditAppointment : createNewAppointment}>
                    {isSubmitting
                      ? (isEditAppointment ? 'Saving...' : 'Creating...')
                      : (isEditAppointment ? 'Save' : 'Create')}
                  </button>
                </div>
              </div>
            </section>
          </div>
        </div>
      )}
      <ReactTooltip
        id='my-tooltip'
        arrowColor='transparent'
        place='bottom-start'
        delayShow={200}
        style={{
          backgroundColor: '#707070',
          fontSize: '10px',
          textAlign: 'center',
          padding: '5px',
          fontSize: '14',
          fontWeight: 400
        }}
      />
    </div>
    // <></>
  );
}
export default PatientAppointment;
